import { eventBus } from 'services/eventBus';
import { logger } from 'services/logger';

export const useBotMessageHandler = () => {
  return (message: Conversation.Message) => {
    if (message.msgFromType !== 'BOT') {
      return;
    }
    try {
      if (!message.extra) {
        return;
      }
      const extra = JSON.parse(message.extra) as Conversation.ExtraInfo;
      if (extra.knowledgeQuery && extra.reqMsgId) {
        eventBus.emit('QAPAIR_CONV_KNOWLEDGE_QUERY_REFETCH', message.conversationId);
      }
    } catch (error) {
      logger.error(`[useBotMessageHandler] error:${JSON.stringify(error)}`);
      return;
    }
  };
};
